export default __webpack_public_path__ + "static/media/cod-warzone.61597723.png";